module.exports = __webpack_public_path__ + "img/icon-normal-done.a71d2508.svg";